// extracted by mini-css-extract-plugin
export default {"container":"ShowCompletedIcon_container__X7FR8","check":"ShowCompletedIcon_check__bqaUC","completed":"ShowCompletedIcon_completed__u5Ast"};